export default [
  {
    'title': 'Funoro',
    'links': {
      'Über uns': '/uber-uns',
      'So funktioniert FUNORO': '/so-funktioniert-funoro',
      'Anmelden': '/anmelden',
      'Karriere': '/karriere',
      'Hilfe Center': '/help',
      'Vertrauen & Sicherheit': '/vertrauen-and-sicherheit',
      'AGBs': '/agbs',
      'Steuer': '/steuer',
      'Nutzungsbedingungen': '/nutzungsbedingungen'
    }
  }
]



// WEBPACK FOOTER //
// ./src/data/footer_links.js